export const COMMON_COLUMNS = [
  { name: 'name', label: 'Name', size: { width: '60%', minWidth: '120px' } },
  {
    name: 'quantity',
    label: 'Qty',
    size: { width: '10%', minWidth: '50px' },
    visibleIf: (props) => props.displayQuantityAndUnitPrice,
  },
  {
    name: 'unitPrice',
    label: 'Price per',
    size: { width: '15%', minWidth: '60px' },
    isMoney: true,
    visibleIf: (props) => props.displayQuantityAndUnitPrice,
  },
  {
    name: 'amount',
    label: 'Amount',
    size: { width: '15%', minWidth: '60px' },
    isMoney: true,
  },
];

export const getColumns = (props = {}) => {
  let columns = COMMON_COLUMNS.filter((col) => !col.visibleIf || col.visibleIf(props));

  if (columns.length < COMMON_COLUMNS.length) {
    columns = columns.map((col, index) => {
      if (index === 0) {
        return { ...col, size: { width: '70%', minWidth: '120px' } };
      }

      return { ...col, size: { width: '30%', minWidth: '60px' } };
    });
  }

  return columns;
};
